import { Domain } from "src/app/model/enum/observations/domain.enum";
import { Subdomain } from "src/app/model/enum/observations/subdomain.enum";
import { NtpeModel } from "src/app/model/observation/ntpe/ntpe.model";


export class NTPERubricHelpers {

    public static getRubricResponseForDomain(observation?: NtpeModel, domain?: Domain, userId?: string) {
        if (userId == observation?.targetUserId) {
            return observation?.targetNTPEObservationDomains?.find(r => r.domain === domain);
        } else if (userId == observation?.evaluatingUserId) {
            return observation?.evalNTPEObservationDomains?.find(r => r.domain === domain);
        } else {
            return null;
        }
    }

    public static getRubricResponeForComponent(observation?: NtpeModel, domain?: Domain, component?: Subdomain, userId?: string) {
        const domainMaster = this.getRubricResponseForDomain(observation, domain, userId);
        let responseComponent = observation?.components?.find(c => c.component === component);
        return domainMaster?.responses?.find(r => r.component === responseComponent?.componentID);
    }

    public static getRubricResponeForComponent_TargetUser(observation?: NtpeModel, domain?: Domain, component?: Subdomain) {
        return this.getRubricResponeForComponent(observation, domain, component, observation?.targetUserId);
    }

    public static getRubricResponeForComponent_EvaluatingUser(observation?: NtpeModel, domain?: Domain, component?: Subdomain) {
        return this.getRubricResponeForComponent(observation, domain, component, observation?.evaluatingUserId);
    }

}